import Header from '../../Components/Header/Header';
import React, { useEffect, useState } from 'react';
import './NewAssignment.css';
import { postCall, putCall } from '../../Services/CommonService';
import { useNavigate, useParams } from 'react-router-dom';
import AssignmentDetailsHeader from '../common/AssignmentDetailsHeader';
import { getUserInfoFromSession } from '../../Services/session.mgmt';
import * as Constants from '../../constants/RepoReactConstants';
import { PINNCALE_LOG_OBJ } from '../../constants/commonJsonConstants';

import { CommonDataService, getcommentStr } from '../../Services/CommonDataService';
import { FcnaDB2Postcall } from '../../api/accountsummary.api';
import { AssignmentService } from '../../Services/AssignmentService';
import BuyerAssignmentInfo from '../../Components/BuyerAssignmentInfo';
import Button from '../../Components/Button/Button';
import { logPinnacleContact } from '../../Services/PinnacleService';

function NewAssignment() {
  const [accountInformation, setAccountInformation] = useState([]);
  const [contractorInfoForComment, setContractorInfoForComment] = useState([]);

  const navigate = useNavigate();
  let { teamWrkBpiNb } = useParams();
  console.log(teamWrkBpiNb);

  const [assignmentDetails, setAssignmentDetails] = useState([]);
  const [buyerCoBuyerInfo, setBuyerCoBuyerInfo] = useState([]);
  const userInfo = getUserInfoFromSession();

  function getCurrentTimestamp() {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // JavaScript months are 0-indexed
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  useEffect(() => {
    function callGetBuyerCobuyerInfo(accountInfoResponse) {
      AssignmentService.getBuyerCobuyerInfo(
        accountInfoResponse?.data?.coBusCd,
        accountInfoResponse?.data?.discorigBranchCd,
        accountInfoResponse?.data?.custAcctNb
      )
        .then((buyerInfoResp) => {
          console.log('getBuyerCobuyer response:', buyerInfoResp);
          setBuyerCoBuyerInfo(buyerInfoResp?.data);
        })
        .catch((error) => {
          console.error('AssignmentService.getBuyerCobuyerInfo error:: ', error);
        });
    }
    function callPromiseAll() {
      Promise.all([
        CommonDataService.getAccountInfo(teamWrkBpiNb, userInfo.cntrctrNb),
        CommonDataService.getCntrctrInfoForComments(userInfo.userid),
        AssignmentService.getAssignmentInfo(teamWrkBpiNb, userInfo.cntrctrNb),
      ])
        .then(([accountInfoResponse, contractorInfoForCommentResponse, assignmentResponse]) => {
          setAccountInformation(accountInfoResponse.data);
          setContractorInfoForComment(contractorInfoForCommentResponse.data);
          setAssignmentDetails(assignmentResponse.data);

          console.log(
            `getBuyerCobuyer Params coBusCd: ${accountInfoResponse?.data?.coBusCd} ` +
            `disorigBranchCd: ${accountInfoResponse?.data?.discorigBranchCd} ` +
            `custAcctNb: ${accountInfoResponse?.data?.custAcctNb}`
          );
          callGetBuyerCobuyerInfo(accountInfoResponse);
        })
        .catch((error) => {
          console.error('An error occurred:', error);
        });
    }
    const fetchcommonInfo = async () => {
      try {
        callPromiseAll();
      } catch (error) {
        // Handle any errors that occur in any of the promises
        console.error('An error occurred:', error);
      }
    };
    fetchcommonInfo();
  }, [teamWrkBpiNb, userInfo.cntrctrNb, userInfo.userid]);


  function Accept() {
    try {
      Promise.all([
        logPinnacleContact(
          accountInformation,
          contractorInfoForComment,
          userInfo,
          Constants.ACTION_ACCEPT,
          Constants.rsACCEPT
        ),
        putCall(
          'processQuestion/updateCntrctAcct?bpiNb=' +
          teamWrkBpiNb +
          '&cntrctrNb=' +
          userInfo.cntrctrNb +
          '&sConfirm=Y&sCsrAction=A'
        ),
        postCall(
          'SqlMgr/insertCPkupLog?actnAm=0.0&actnCd=3&bpiNb=' +
          teamWrkBpiNb +
          '&cntrctrNb=' +
          userInfo.cntrctrNb +
          '&userId=' +
          userInfo.userid
        ),
        FcnaDB2Postcall({
          acctNb: accountInformation?.custAcctNb,
          coBusCd: accountInformation?.coBusCd,
          transTypeCd: 21,
          sourceSystemCode: 12,
          lastUpdatedUserIdentificationCode: 'FCREPO',
          transactionDataText: teamWrkBpiNb + ';ACCEPT',
          isImmediate: true,
        }),
      ])
        .then(([pinnResp, putResp, postResp, fcnadb2Resp]) => {
          console.log('Pinnacle Response:', JSON.stringify(pinnResp));
          console.log('putCall Response:', JSON.stringify(putResp));
          console.log('postCall Response:', JSON.stringify(postResp));
          console.log('FcnaDB2Postcall Response:', JSON.stringify(fcnadb2Resp));
        })
        .catch((error) => {
          console.error('Error in Promise.all:', error);
        })
        .finally(() => {
          navigate('/outstandingAssignment');
        });
    } catch (error) {
      console.log('FcnaDB2Postcall Error: ' + error);
    }
  }

  function Decline() {
    putCall(
      'processQuestion/updateCntrctAcct?bpiNb=' +
      teamWrkBpiNb +
      '&cntrctrNb=' +
      userInfo.cntrctrNb +
      '&sConfirm=Y&sCsrAction=R'
    ).then((response) => console.log(response));
    postCall(
      'SqlMgr/insertCPkupLog?actnAm=0.0&actnCd=4&bpiNb=' +
        teamWrkBpiNb +
        '&cntrctrNb=' +
        userInfo.cntrctrNb +
        '&userId=' +
        userInfo.userid
    ).then((response) => {
      console.log(response.status);
      navigate('/outstandingAssignment');
    });
   
  }

  return (
    <>
      <Header heading="New Assignment" />
      <br />
      <AssignmentDetailsHeader bpiNo={teamWrkBpiNb} />
      <br />
      <div>
        <BuyerAssignmentInfo buyerCoBuyerInfo={buyerCoBuyerInfo} assignmentDetails={assignmentDetails} />
        <br />
        <section>
          <div className="center">
            <Button label="Accept" onClick={Accept}></Button>
            <Button label="Decline" onClick={Decline}></Button>
          </div>
        </section>
      </div>
    </>
  );
}

export default NewAssignment;
